export default "__VITE_ASSET__CRMZdz3J__"